import { Directive, HostListener } from '@angular/core';

/**
 * Allows the aside to be toggled via click.
 */
@Directive({
  selector: '[appAsideMenuToggler]',
  standalone: false,
})
export class AsideToggleDirective {
  constructor() {}

  @HostListener('click', ['$event'])
  public toggleOpen($event: Event) {
    $event.preventDefault();
    document.querySelector('body').classList.toggle('aside-menu-hidden');
  }
}
